module.exports = __webpack_public_path__ + "img/profile.8db793e5.svg";